import { Button } from '@/components/ui/button';

/**
 * Shown when /map's loading overlay hits its ceiling and the map still hasn't
 * reported ready (ISS-136): a stalled Mapbox style/tile load, WebGL off, or a
 * hung sign-in or units request. The sidebar and list stay usable meanwhile.
 * z-[110]: above the loading overlay (z-[100]) while it fades out (Seer #955).
 */
export function MapSlowNotice() {
  return (
    <div
      role="status"
      className="fixed left-1/2 top-20 z-[110] flex -translate-x-1/2 items-center gap-3 rounded-md border border-border bg-card px-4 py-2 text-sm text-muted-foreground shadow-sm"
    >
      <span>The map is taking longer than usual to load.</span>
      <Button variant="outline" size="sm" onClick={() => window.location.reload()}>
        Reload
      </Button>
    </div>
  );
}
